import ConversationProfil from '../../../features/supervision/conversations/components/ConversationProfil/ConversationProfil';
import { PageTable, Header } from '/src/layouts/page';
import { useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ConversationCompletedService from '/src/features/supervision/conversations/services/ConversationCompletedService';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';

function ConversationProfilPage() {
    const params = useParams();
    const navigate = useNavigate();
    const toast = useToastDispatchContext();

    const copyPageLink = () => {
        navigator.clipboard.writeText(window.location.href).then(() => {
            toast.success("Link copied", "You can paste this link to share this conversation !", 5000);
        })
    }

    return (
        <PageTable>

            <>
                <Header title={
                    <div style={{display : "flex", alignItems : "center", gap : "10px"}}>
                        <IconButton onClick={() => { navigate("/supervision/conversations/list") }} className="main-iconButton profil_action main_add-button space_tableButton block_button" icon={"fas fa-arrow-left "} />
                        <span>{"Conversation profil -"} <span style={{ fontSize: "x-large", fontStyle: "italic" }}>{params.id}</span> </span>

                    </div>}>
                    <IconButton onClick={copyPageLink} className="main-iconButton profil_action main_add-button block_button" style={{ marginRight: "35px",marginTop:"20px" }} icon={"fas fa-link"} title="Copy conversation link" />
                </Header>

                <ConversationProfil id={params.id} />
            </>


        </PageTable >
    );
}

export default ConversationProfilPage;